import React from 'react';
import { Fade } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import { UserRole } from 'globals/types';
import { isUserRole } from 'globals/utils';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import DashboardToggleChart from './DashboardToggleChart';
import { ContainerBox, WrapperBox } from './Dashboard.style-elements';
import InviteCustomerForm from './InviteCustomerForm';
import RecentInvitations from './RecentInvitations';
import LatestReports from './LatestReports';
import Leaderboard from './Leaderboard';
import MagicLink from './MagicLink';

const Dashboard: React.FC = () => {
  const { userRole } = useAppContext();
  const isAdminOrLeader = isUserRole(userRole, [
    UserRole.ADMIN,
    UserRole.LEADER,
  ]);
  return (
    <Fade in timeout={1000}>
      <WrapperBox>
        <FsGridContainer>
          <FsGridItem xs={12}>
            <DashboardToggleChart />
          </FsGridItem>
          <FsGridItem xs={12} lg={5}>
            <ContainerBox>
              <InviteCustomerForm />
              <MagicLink withMarginTop />
            </ContainerBox>
          </FsGridItem>
          <FsGridItem xs={12} lg={7}>
            <RecentInvitations />
          </FsGridItem>
          <FsGridItem xs={12} lg={isAdminOrLeader ? 8 : 12} isFlex>
            <LatestReports />
          </FsGridItem>
          {isAdminOrLeader && (
            <FsGridItem xs={12} lg={4} isFlex>
              <Leaderboard />
            </FsGridItem>
          )}
        </FsGridContainer>
      </WrapperBox>
    </Fade>
  );
};

export default Dashboard;
